import { getEffect } from 'nike-re-framejs';
import { DEBUG_CONSOLE_MODE } from '../common/logs';

export const ENABLE_DEVELOPER_TOOLS =
    (process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'test') || DEBUG_CONSOLE_MODE;

export const extractMiddlewareCtx = ctx => {
    const eventName = ctx.getIn(['coeffects', 'event'])[0];
    const eventArgs = ctx.getIn(['coeffects', 'event'])[1];
    const db = getEffect(ctx, 'db');

    return {
        eventName,
        eventArgs,
        db
    };
};
